module.exports = __webpack_public_path__ + "img/saba-island.0506f2bf.svg";